import { Modal } from "@mui/material";

export default function ExerciseBuilderModal({
  title,
  openModal,
  handleModalClose,
  handleYes,
  handleNo,
}) {
  return (
    <Modal
      open={openModal}
      onClose={handleModalClose}
      aria-labelledby="exit-without-saving-title"
      aria-describedby="exit-without-saving-description"
    >
      <div className="dlt_wrapper" style={{ position: "fixed" }}>
        <div className="dbl_place_on_page">
          <div
            className="dlt_surround"
            style={{
              maxWidth: "800px",
              width: "max-content",
              paddingTop: "30px",
              paddingBottom: "30px",
              position: "relative",
            }}
          >
            <div className="modal_x_button" onClick={handleModalClose}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="30"
                height="30"
                fill="currentColor"
                className="bi bi-x"
                viewBox="0 0 16 16"
              >
                <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708" />
              </svg>
            </div>
            <div className="dlt_title">{title || "Do you want to exit without saving?"}</div>
            {/* <div className="dlt_description">
                  <p> Are you sure you want to save this program as unassigned?</p>
                </div> */}
            <div className="dlt_exit_btm new_prog_modal_btn_container">
              <div
                className="dlt_exit_btn dlt_eb_scnd new_prog_modal_btl_style"
                onClick={handleYes}
              >
                Yes
              </div>
              <div
                className="dlt_exit_btn dlt_eb_first new_prog_modal_btl_style"
                onClick={handleNo}
              >
                Save & Exit
              </div>
              <div
                className="dlt_exit_btn dlt_eb_scnd new_prog_modal_btl_style"
                style={{ background: "#166273" }}
                onClick={handleModalClose}
              >
                Continue Editing
              </div>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
}
